import interceptedAxios from '../../../utils/interceptedAxios'

export function fetchDeviceParamsConfig (
  assetId: string, assetTypeId: string,
  onSuccess: (paramList: any, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/asset/${assetId}/paramconfig?assetTypeId=${assetTypeId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
